import { action } from 'typesafe-actions';
import localStorage from 'local-storage';
import history from 'app/routes/history';
import { IPagination } from 'app/types/common';
import { ClubsActionTypes as types } from './types';

/* ********************************* APP ACTIONS ********************************* */

export const createClub = (data): any => action(types.CREATE_CLUB_REQUESTED, data);

export const updateClub = (data): any => action(types.UPDATE_CLUB_REQUESTED, data);

export const deleteClub = (clubId): any => action(types.DELETE_CLUB_REQUESTED, clubId);

export const getClub = (clubId): any => action(types.GET_CLUB_REQUESTED, clubId);

export const getAllClubs = (
  pagination: IPagination = undefined,
  compile = true,
): any => action(types.GET_ALL_CLUBS_REQUESTED, { pagination, compile });

export const selectClub = (clubId): any => action(types.SELECT_CLUB_REQUESTED, { currentClubId: clubId });

export const selectLastClub = (): any => action(types.SELECT_LAST_CLUB_REQUESTED, {});

/* ********************************* SAGA ACTIONS ********************************* */
export const sagaActions = {
  createClubPending: (payload): any => action(types.CREATE_CLUB_PENDING, payload),
  createClubSuccess: (response): any => action(types.CREATE_CLUB_SUCCESS, {
    clubsById: response.entities.clubs,
    currentClubId: response.result,
  }),
  updateClubPending: (payload): any => action(types.UPDATE_CLUB_PENDING, payload),
  updateClubSuccess: (response): any => action(types.UPDATE_CLUB_SUCCESS, {
    clubsById: response.entities.clubs,
    currentClubId: response.result,
  }),
  updateClubFailed: (error): any => action(types.UPDATE_CLUB_FAIL, { backendErrors: error }),
  deleteClubFailed: (error): any => action(types.DELETE_CLUB_FAIL, { backendErrors: error }),
  deleteClubPending: (): any => action(types.DELETE_CLUB_PENDING, {}),
  deleteClubSuccess: (userId): any => {
    localStorage.set(userId, {});
    history.push('/clubs');

    return action(types.DELETE_CLUB_SUCCESS, {
      currentClubId: null,
    });
  },
  getClubPending: (): any => action(types.GET_CLUB_PENDING, {}),
  getClubSuccess: (response): any => action(types.GET_CLUB_SUCCESS, {
    clubsById: response.entities.clubs,
    currentClubId: response.result,
  }),
  getClubFailed: (error): any => action(types.GET_CLUB_FAIL, { backendErrors: error }),
  getAllClubsPending: (pagination): any => action(types.GET_ALL_CLUBS_PENDING, { pagination }),
  getAllClubsSuccess: (response, meta): any => action(types.GET_ALL_CLUBS_SUCCESS, {
    clubsById: response.entities.clubs,
    clubIds: response.result,
    meta,
  }),
  getAllClubsFailed: (error): any => action(types.GET_ALL_CLUBS_FAIL, { backendErrors: error }),
  createClubFailed: (error): any => action(types.CREATE_CLUB_FAIL, { backendErrors: error }),
  selectLastClubPending: (): any => action(types.SELECT_LAST_CLUB_PENDING, {}),
  selectLastClubFinished: (clubId): any => action(types.SELECT_LAST_CLUB_FINISHED, { currentClubId: clubId }),
};

export default null;
